export default __webpack_public_path__ + "cff6e9a19c23b700ffc171aac2f9081a.png";